<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >排队情况</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="虚拟机" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            field="status"
                            title="状态-操作"
                            width="120"
                            :title-help="{ message: '排队中点击按钮取消排队' }"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    icon="fa fa-stop"
                                    size="small"
                                    @click="delQueueItem(row)"
                                    :disabled="checkdisabled(row)"
                                    round
                                    >取消排队
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="Abbr"
                            title="机器人简称"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="虚拟机名称"
                            width="160"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="FlowName"
                            title="流程/项目名称"
                            min-width="120"
                            sortable
                            resizable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="业务人员"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="MailAddress"
                            title="邮箱"
                            width="200"
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="leve"
                            title="优先级"
                            width="100"
                            sortable
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="创建时间"
                            width="160"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="platform"
                            title="platform"
                            width="10"
                            sortable
                            :visible="false"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        v-if="false"
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive } from "vue";
import { VXETable } from "vxe-table";

export default {
    name: "QueueList",
    data() {
        const pageHeight = window.innerHeight - 260 + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                searchKey: "",
                selectMac: "",
            },
        });
        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            tableHeight: 0,
        };
    },
    methods: {
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [this.toolbar.formData.selectMac],
            };
            this.$api.jobManageAPI
                .getQueueList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        checkdisabled(row) {
            if (row.FlowName == null || row.FlowName == "") {
                return true;
            }
            if (this.$store.state.isAdmin == "1") {
                return false;
            }
            if (this.$store.state.email == row.MailAddress) {
                return false;
            }
            return true;
        },
        //取消一个队列
        async delQueueItem(row) {
            const type = await VXETable.modal.confirm("您确定要取消排队吗?");
            if (type === "confirm") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    actionType: "1",
                    actionKey: [
                        row.Id,
                        row.FlowName,
                        this.$store.state.userName,
                        row.platform,
                    ],
                };
                this.$api.jobManageAPI
                    .delQueueItem(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        // console.log(res.data.Data);
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        bindPC() {
            this.$api.systemManageAPI
                .getMachineList()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.PcName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.selectMac = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.bindPC();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>
<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
